import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { from, of } from 'rxjs';
import { catchError, concatMap, first, map, switchMap } from 'rxjs/operators';

import { AZURE_CA_URLS } from '../../shared/enums/HttpStatusCodes';
import { NativeStorageNamesV2, PREMIADOS_ENDPOINTS } from '../../shared/models/Constants';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    errorSeccionesPremiados,
    errorTokenPremiados,
    getSeccionesPremiados,
    getTokenPremiados,
    successSeccionesPremiados,
    successTokenPremiados,
} from '../actions';
import { IIntervalSave } from './../../shared/enums/UpdateInfo';
import { ISections } from './../../shared/models/ProgramClose';
import { StorageData } from './../../shared/services/utilities/storage-data.class';

@Injectable()
export class PremiadosEffets {
    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
        , private translate: TranslateService
    ) { }

    public getTokenPremiados$ = createEffect(
        () => this.actions$.pipe(
            ofType(getTokenPremiados),
            switchMap(actions => this.httpS.executeRequestByUser(PREMIADOS_ENDPOINTS.post_obtener_token, actions, this.httpS.getAzureCAUrl(AZURE_CA_URLS.INTEGRACIONES))
                .pipe(
                    map(resp => successTokenPremiados(resp)),
                    catchError((err: Error) => of(errorTokenPremiados({ payload: err })))
                )
            )
        )
    );

    public getSeccionesPremiados$ = createEffect(
        () => this.actions$.pipe(
            ofType(getSeccionesPremiados),
            switchMap(
                actions => from(StorageData.getDataStorage(NativeStorageNamesV2.ObtenerSeccionesPremiados))
                    .pipe(
                        concatMap((storage: ISaveSectionsPremia2) => this.translate.get('Miscellaneous.updateinterval5').pipe(first(), map((UpdateInterval5: IIntervalSave) => ({ storage, UpdateInterval5 })))),
                        concatMap(({ storage, UpdateInterval5 }) => this.httpS.getStorage(storage, NativeStorageNamesV2.ObtenerSeccionesPremiados, UpdateInterval5, 'executeRequestByUser', PREMIADOS_ENDPOINTS.post_obtener_secciones, actions, this.httpS.getAzureCAUrl(AZURE_CA_URLS.INTEGRACIONES)))
                    )
            ),
            map(resp => successSeccionesPremiados(resp)),
            catchError((err: Error) => of(errorSeccionesPremiados({ payload: err })))
        )
    );

}

interface ISaveSectionsPremia2 {
    fecha: string;
    data: ISections[];
}
